import { render } from "./PersonaFull.vue?vue&type=template&id=ff035f8e"
import script from "./PersonaFull.vue?vue&type=script&lang=js"
export * from "./PersonaFull.vue?vue&type=script&lang=js"

import "./PersonaFull.vue?vue&type=style&index=0&id=ff035f8e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__